import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Images from '../../assets/images/Images';

const StyledPill = styled.div`
  align-items: center;
  background-color: #FBFBFB;
  border-radius: 50px;
  display: flex;
  font-family: AvenirLTStd-Light;
  color: #161615;
  margin-bottom: 5px;

  &.header {
    background-color: transparent;

    & div {
      background-color: transparent;
      font-family: AvenirNextLTPro-Bold;
    }
  }

  & .content {
    display: flex;
    border-radius: 50px;

    & > div {
      flex: 1 0 33%;
      max-width: 33%;
    }

    & .countryHeader {
      align-items: center;
      background-color: transparent;
      color: #FBFBFB;
      display: flex;
      justify-content: center;
      text-align: center;
    }

    & .groupWrapper {
      display: flex;
      background-color: #E3DFDD;
      border-radius: 50px;
    }

    & .groupLabel {
      display: block;
      flex-direction: row;
      background-color: #E3DFDD;
      color: black;
      border-radius: 50px;
      justify-content: center;
      padding: 5px;
      align-items: center;
      text-transform: uppercase;
      text-align: center;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      & img {
        height: 15px;
        max-width: 100%;
      }
    }

    & .primaryWrapper {
      border-radius: 50px;
      display: flex;
      background-color: #d3d3d3;
      flex: 1 0 34%;
      max-width: none;
    }

    & .primaryLabel {
      display: flex;
      flex: 1;
      flex-direction: row;
      background-color: #E3DFDD;
      color: black;
      border-radius: 50px;
      justify-content: center;
      padding: 5px;
      align-items: center;
      text-align: center;
    }
  }

  &.dark {
    & .content {
      background-color: #464646;
    }
  }

  &.light {
    & .content {
      background-color: #8B8B8B;
    }
  }

  & .ranking-position {
    display: flex;
    flex: 0.1;
    justify-content: center;
  }

  &.mapfre-row {
    background-color: #AE0018;
    color: #FBFBFB;

    & .content {
      background-color: #AE0018;
    }

    & img {
      height: 15px;
    }
  }

  @media (max-width: 480px) {
    font-size: 10px;

    &.mapfre-row .content .groupLabel img {
      height: 7px;
    }
  }

  @media (max-height: 900px) {
    & .content .groupLabel img {
      height: 13px;
    }
  }
`;

interface PillRowProps {
  number?: number;
  record: PillRecord;
  isDark: boolean;
}

export interface PillRecord {
  company_group: string,
  premiums: number,
  registered_office: string,
}

export const HeaderPillRow: React.FC<{ year: number, isDark: boolean, currency?: string }> = ({ year, isDark, currency = 'M€' }) => {
  const { t } = useTranslation();

  return (
    <StyledPill className={ classNames('header', isDark ? 'dark' : 'light') }>
        <div className={'ranking-position'}></div>
        <div style={{flex: 2}}>
          <div className='content'>
              <div className={'groupWrapper'}>
                  <div className={'groupLabel'}>
                      { t('pillsTable.group') }
                  </div>
              </div>
              <div className={'countryHeader'}>
                { t('pillsTable.country') }
              </div>
              <div className={'primaryWrapper'}>
                  <div className={'primaryLabel'}>
                      { t('pillsTable.premiums') } { year } ({ currency })
                  </div>
              </div>
          </div>
        </div>
    </StyledPill>
  )
};

const PillRow: React.FC<PillRowProps> = ({ number, record, isDark }) => {
    const companyGroup = record.company_group;

    const { t, i18n } = useTranslation();
    const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || '';

    // @ts-ignore
    const image = Images.groupIcons[companyGroup.toLowerCase().trim()];
    // const groupLabel =
    //   image
    //     ? (<img src={ image } alt={ companyGroup } />)
    //     : (<span>{ companyGroup }</span>);
    const groupLabel = <>{ companyGroup }</>;

    const country = record.registered_office
      ? t(`countries.${record.registered_office.toLowerCase()}`)
      : '-';

    return (
        <StyledPill className={ classNames(isDark ? 'dark' : 'light', { 'mapfre-row': record.company_group === 'MAPFRE' }) }>
            <div className='ranking-position'>
              { number ? `${number}°` : null }
            </div>
            <div style={{flex: 2}}>
              <div className='content'>
                  <div className={'groupWrapper'}>
                      <div className={'groupLabel'} title={ companyGroup }>
                          { groupLabel }
                      </div>
                  </div>
                  <div className={'countryHeader'}>
                    { country }
                  </div>
                  <div className={'primaryWrapper'}>
                      <div className={'primaryLabel'}>
                          { new Intl.NumberFormat(getCurrentLng() === 'es' ? 'de' : getCurrentLng()).format(Math.round(record.premiums)) }
                      </div>
                  </div>
              </div>
            </div>
        </StyledPill>
    )
};

export default PillRow;
